import "./Navbar.css";
import React, { useContext, useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import contactContext from "../../context/contact/contactcontext";
import landingContext from "../../context/landing/landingcontext";
import mainmenuContext from "../../context/mainmenu/mainmenucontext";
import servicesContext from "../../context/services/servicescontext";

function Navbar() {
  const { contactInfo } = useContext(contactContext);
  const { landingContent } = useContext(landingContext);
  const { menus } = useContext(mainmenuContext);
  const { services } = useContext(servicesContext);
  const location = useLocation();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location]);

  const phone = contactInfo && contactInfo.phone ? JSON.parse(contactInfo.phone) : { phone: "080 2334 7276" };
  const email = contactInfo && contactInfo.email ? JSON.parse(contactInfo.email) : { email: "lakshmimaternityhome@gmail.com" };

  const currentPath = location.pathname;

  return (
    <div className="site-header-wrapper">
      {/* Top Utility Bar */}
      <div className="util">
        <div className="wrap">
          <a href={`tel:${phone.phone ? phone.phone.replace(/\s+/g, '') : "08023347276"}`} aria-label="Call Lakshmi Maternity and Surgical Centre">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
              <path d="M22 16.9v3a2 2 0 0 1-2.2 2 19.8 19.8 0 0 1-8.6-3.1 19.5 19.5 0 0 1-6-6A19.8 19.8 0 0 1 2.1 4.2 2 2 0 0 1 4.1 2h3a2 2 0 0 1 2 1.7c.1 1 .4 1.9.7 2.8a2 2 0 0 1-.5 2.1L8.1 9.9a16 16 0 0 0 6 6l1.3-1.2a2 2 0 0 1 2.1-.5c.9.3 1.8.6 2.8.7a2 2 0 0 1 1.7 2Z"/>
            </svg>
            {phone.phone || "080 2334 7276"}
          </a>
          <a className="util-email" href={`mailto:${email.email || "lakshmimaternityhome@gmail.com"}`}>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
              <rect x="2" y="4" width="20" height="16" rx="2"/>
              <path d="m2 7 10 6 10-6"/>
            </svg>
            {email.email || "lakshmimaternityhome@gmail.com"}
          </a>
          <span className="spacer"></span>
          <div className="util-social-links">
            <a className="util-extra" href="https://www.instagram.com/lakshmimaternitysurgicalcenter/" target="_blank" rel="noopener noreferrer" title="Instagram" aria-label="Instagram">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
                <rect x="3" y="3" width="18" height="18" rx="5"/>
                <circle cx="12" cy="12" r="4"/>
                <circle cx="17.5" cy="6.5" r="1" fill="currentColor" stroke="none"/>
              </svg>
              <span>Instagram</span>
            </a>
            <a className="util-extra" href="https://www.facebook.com/Lakshmimaternityhospital/" target="_blank" rel="noopener noreferrer" title="Facebook" aria-label="Facebook">
              <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"/>
              </svg>
              <span>Facebook</span>
            </a>
            <a className="util-extra" href="https://www.youtube.com/channel/UCyRqaGN2QxNHqrKOlD-3Gbw" target="_blank" rel="noopener noreferrer" title="YouTube" aria-label="YouTube">
              <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
              </svg>
              <span>YouTube</span>
            </a>
            <a className="util-extra" href="https://www.linkedin.com/company/lakshmi-maternity-surgical-center/" target="_blank" rel="noopener noreferrer" title="LinkedIn" aria-label="LinkedIn">
              <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6zM2 9h4v12H2zM4 2a2 2 0 1 1-2 2 2 2 0 0 1 2-2z"/>
              </svg>
              <span>LinkedIn</span>
            </a>
            <a className="util-extra" href="https://x.com/LMaternityBLR" target="_blank" rel="noopener noreferrer" title="X (Twitter)" aria-label="X (Twitter)">
              <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
              </svg>
              <span>X</span>
            </a>
          </div>
          <a className="util-extra util-map" href="https://maps.google.com/?q=Lakshmi+Maternity+%26+Surgical+Centre,+Margosa+Road,+Malleswaram,+Bangalore" target="_blank" rel="noopener noreferrer">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
              <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z"/>
              <circle cx="12" cy="10" r="3"/>
            </svg>
            Malleswaram, Bangalore
          </a>
        </div>
      </div>

      {/* Main Sticky Header */}
      <header className="hdr">
        <div className="wrap">
          <Link className="brand" to="/">
            <img
              src="/img/logo.png"
              alt={landingContent && landingContent.organization_name ? landingContent.organization_name : "Lakshmi Maternity and Surgical Centre"}
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = "/img/uplaods/lakshmi_maternity.png";
              }}
            />
          </Link>

          {/* Quick Call Button for Mobile */}
          <a className="call-btn" href={`tel:${phone.phone ? phone.phone.replace(/\s+/g, '') : "08023347276"}`} aria-label="Call Centre">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
              <path d="M22 16.9v3a2 2 0 0 1-2.2 2 19.8 19.8 0 0 1-8.6-3.1 19.5 19.5 0 0 1-6-6A19.8 19.8 0 0 1 2.1 4.2 2 2 0 0 1 4.1 2h3a2 2 0 0 1 2 1.7c.1 1 .4 1.9.7 2.8a2 2 0 0 1-.5 2.1L8.1 9.9a16 16 0 0 0 6 6l1.3-1.2a2 2 0 0 1 2.1-.5c.9.3 1.8.6 2.8.7a2 2 0 0 1 1.7 2Z"/>
            </svg>
          </a>

          {/* Mobile Menu Toggle Button */}
          <button
            className="menu-btn"
            id="menuBtn"
            aria-expanded={isMobileMenuOpen}
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            {isMobileMenuOpen ? "Close" : "Menu"}
          </button>

          {/* Multi-Page Navigation Links */}
          <nav className={`nav ${isMobileMenuOpen ? "open" : ""}`} id="nav">
            {menus && menus.length > 0 ? (
              menus.map((item) => {
                if (item.subMenus && item.subMenus.length > 0) {
                  return (
                    <div className="nav-dropdown" key={item.id}>
                      <span className="nav-item-btn">
                        {item.title}
                        <svg width="10" height="6" viewBox="0 0 10 6" fill="currentColor">
                          <path d="M0 0l5 6 5-6z"/>
                        </svg>
                      </span>
                      <div className="nav-dropdown-menu">
                        {item.subMenus.map((subMenuItem) => (
                          <Link
                            key={subMenuItem.id}
                            to={subMenuItem.slug ? (subMenuItem.slug.startsWith('/') ? subMenuItem.slug : `/${subMenuItem.slug}`) : '/'}
                            onClick={() => setIsMobileMenuOpen(false)}
                          >
                            {subMenuItem.title}
                          </Link>
                        ))}
                      </div>
                    </div>
                  );
                } else {
                  return (
                    <Link
                      key={item.id}
                      to={item.slug ? (item.slug.startsWith('/') ? item.slug : `/${item.slug}`) : '/'}
                      className={currentPath === (item.slug.startsWith('/') ? item.slug : `/${item.slug}`) ? "active" : ""}
                      onClick={() => setIsMobileMenuOpen(false)}
                    >
                      {item.title}
                    </Link>
                  );
                }
              })
            ) : (
              <>
                <Link to="/" className={currentPath === "/" ? "active" : ""} onClick={() => setIsMobileMenuOpen(false)}>
                  Home
                </Link>
                <Link to="/about" className={currentPath === "/about" ? "active" : ""} onClick={() => setIsMobileMenuOpen(false)}>
                  About
                </Link>
                <div className="nav-dropdown">
                  <span className={`nav-item-btn ${currentPath.startsWith("/services") ? "active" : ""}`}>
                    Services
                    <svg width="10" height="6" viewBox="0 0 10 6" fill="currentColor">
                      <path d="M0 0l5 6 5-6z"/>
                    </svg>
                  </span>
                  <div className="nav-dropdown-menu">
                    {services && services.length > 0 ? (
                      services.map(svc => (
                        <Link key={svc.id} to={`/services/${svc.slug}`} onClick={() => setIsMobileMenuOpen(false)}>
                          {svc.title}
                        </Link>
                      ))
                    ) : (
                      <>
                        <Link to="/services/gynaecology" onClick={() => setIsMobileMenuOpen(false)}>Gynaecology &amp; Maternity</Link>
                        <Link to="/services/pediatric" onClick={() => setIsMobileMenuOpen(false)}>Paediatrics &amp; Child Care</Link>
                        <Link to="/services/general-services" onClick={() => setIsMobileMenuOpen(false)}>General Services</Link>
                      </>
                    )}
                  </div>
                </div>
                <Link to="/doctors" className={currentPath === "/doctors" ? "active" : ""} onClick={() => setIsMobileMenuOpen(false)}>
                  Doctors
                </Link>
                <Link to="/blogs" className={currentPath.startsWith("/blogs") ? "active" : ""} onClick={() => setIsMobileMenuOpen(false)}>
                  Insights
                </Link>
                <Link to="/contact" className={currentPath === "/contact" ? "active" : ""} onClick={() => setIsMobileMenuOpen(false)}>
                  Contact
                </Link>
              </>
            )}
            <Link className="btn-appointment" to="/appointment" onClick={() => setIsMobileMenuOpen(false)}>
              Book an Appointment
            </Link>
          </nav>
        </div>
      </header>
    </div>
  );
}

export default Navbar;



